<template>
<div style="padding:10px 0 20px 0;background-color:#fff;" class="form-azzurro">
<div class="yo-align-center yo-color-secondary yo-text-xl yo-text-bold" style="padding-bottom:20px;">Cerca tutti gli eventi</div>

<div class="row pad-in " >

  <div class="search col s3 m1 yo-align-center" style="">
    <img v-if="tipo==0" src="../assets/ico-search-res.png" style="height:40px;"/>
    <img v-if="tipo==1" src="../assets/ico-search-fad.png" style="height:40px;"/>
  </div>
  <div class="search col s9 m5"><el-select v-model="tipo" placeholder="Scegli il tipo di corso" style="width:100%;">
    <el-option label="Residenziale" :value="0"></el-option>
    <el-option label="Formazione a distanza" :value="1"></el-option>
  </el-select></div>

  
  <div v-if="tipo==0" class="search col s3 m1 yo-align-center clear "><img src="../assets/ico-search-area.png" style="height:40px;"/></div>
  <div v-if="tipo==0" class="search col s9 m5"><el-input v-model="citta" clearable placeholder="città" style="width:100%;"></el-input></div>
 

  <div v-if="tipo==0" class="search col s3 m1 yo-align-center  "><img src="../assets/ico-search-giorno.png" style="height:40px;"/></div>
  <div v-if="tipo==0" class="search col s9 m2m"><el-date-picker v-model="iniziail" type="date" placeholder="dal giorno" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker></div>
  <div v-if="tipo==0" class="search col s9 m2m offset-s3 "><el-date-picker v-model="finisceil" type="date" placeholder="al giorno" style="width:100%;" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker></div>


   <div class="search col s3 m1 yo-align-center clear"><img src="../assets/ico-search-interesse.png" style="height:40px;"/></div>
   <div class="search col s9 m5"><el-select v-model="interesse" clearable placeholder="Scegliere l'area di interesse" style="width:100%;">
      <el-option v-for="item in $teras._interesse" :key="item.id" :label="item.nome" :value="item.id"></el-option>
   </el-select></div>

  <div class="search col s3 m1 yo-align-center"><img src="../assets/ico-search-provider.png" style="height:40px;"/></div>
  <div class="search col s9 m5"><el-select v-model="provider" clearable placeholder="Scegliere il provider" style="width:100%;">
    <el-option v-for="item in $teras._provider" :key="item.id" :label="item.nome" :value="item.id"></el-option>
  </el-select></div>


   <div class="col s12 m5 offset-m7">
      <router-link :to="'/evento-search/'+tipo+'/'+(iniziail || ' ')+'/'+(finisceil || ' ')+'/'+(interesse || ' ')+'/'+(provider || ' ')+'/'+(citta || ' ')" class="yo-bg-color-secondary yo-block white yo-align-center yo-valign-text-center yo-text-n" style="height:40px;">Cerca</router-link>
   </div>

</div>


</div>
</template>

<script>

export default {
  /*
  props: {
   tipo: Number
   ,iniziail: String
   ,finisceil: String
   ,interesse: Number
   ,provider: Number
   ,citta:String
  },
  */
  created() {

     //if(this.tipo!=1)
      //this.tipo=0
    this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
   },
   methods: {
      fetchData () {
        console.log("************************* FETCHDATA FROM MODULO")
        
         this.finisceil = (this.$route.params.finisceil || ' ')
         this.iniziail = (this.$route.params.iniziail || this.$moment().format('YYYY-MM-DD'))
         this.tipo = (this.$route.params.tipo*1 || 0)
         this.interesse = (this.$route.params.interesse*1  || '')
         this.provider = (this.$route.params.provider*1  || ' ')
         
         if(this.$route.params.citta == ' ')
          this.$route.params.citta = ''
         this.citta = (this.$route.params.citta  || '')

         console.log((this.$route.params.iniziail || this.$moment().format('YYYY-MM-DD')))


      }
   },
  data(){
        return{
          tipo:0
         ,iniziail: ''
         ,finisceil: ''
         ,interesse: ''
         ,provider: ''
         ,citta:''

        }
    },
  computed: {
    aevheight: function () {
      
    }
  }
}
</script>


<style>
.col.search{
   height:60px;
}
.evento-elenco-fad > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #0E1C3C;
}
.evento-elenco-fad .side{
   background: #379EC2;

   padding:0 0 0 20px !important;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .side {
  background: #0E1C3C;
}
.evento-elenco-fad .info div{
   background: #0E1C3C;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .info div{
  background: #379EC2;
}
.evento-elenco-fad .main{
   background: #379EC2;
 
   padding:0 0 0 20px !important;
}
.evento-elenco-fad  > .evento:nth-child(2n)  .main {
  background: #0E1C3C;
}


.evento-elenco-fad.pediatria .provider{
   border-bottom:10px solid #EC008C;
}
.evento-elenco-fad.pediatria > .evento:nth-child(2n) .provider{
  border-bottom:10px solid #FBCCE8;
}
.evento-elenco-fad.pediatria .side{
   background: #EC008C;

}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .side {
  background: #FBCCE8;
  color:#353535;
}
.evento-elenco-fad.pediatria .info div{
   background: #FBCCE8;
   color:#353535;
}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .info div{
  background: #EC008C;
  color:#fff;
}
.evento-elenco-fad.pediatria .main{
   background: #EC008C;

}
.evento-elenco-fad.pediatria  > .evento:nth-child(2n)  .main {
  background: #FBCCE8;
  color:#353535;
}



</style>



// WEBPACK FOOTER //
// src/components/Evento-search-form.vue